import { color } from "@material-ui/system"
import { useContextState } from "../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: (isEven: boolean, isParent: boolean) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            padding: isParent ? '0px 0px 0px 0px' : '24px 0px 24px 24px'/* 3 */,
            bgcolor: isParent
                ? 'transparent'
                : isEven
                    ? 'rgba(25,118,210,0.05)'
                    : 'white'
        }),
    }
}

export { useStyles }
